<template>
  <div class="main-wrapper">
    <div>
      <div class="nedbank-pay-auth-wrapper content-wrapper">
        <div class="login-form-wrapper">
          <loading instruction="Handling callback from Nedbank Direct..." />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '../components/Loading.vue'
import axios from '@/wrapper'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'nedbankAuthCallback',
  components: {
    Loading,
  },
  created() {
    this.setUpNedbankAuthResponse()
  },
  data() {
    return {
      preHandle: true,
    }
  },
  computed: {
    ...mapState('signalRMessage', ['message']),
  },
  methods: {
    ...mapActions('signalRMessage', ['setRequest']),
    async setUpNedbankAuthResponse() {
      const request = { ...this.message.request }
      request.isProcessing = true
      this.setRequest(request)

      const queryString = new URLSearchParams(this.$route.query).toString()
      const payload = {
        QueryParams: queryString,
      }

      await axios
        .post(`bankApi/nedbankPay/handleAuthResponseV2`, payload)
        .then(
          ({
            data: {
              Success: success,
              TransactionId: transactionId,
              Code: code,
              RouteName: routeName,
            },
          }) => {
            if (success) {
              this.$router.push({
                name: 'nedbankFinalisePayment',
                query: { transactionId: transactionId, code: code },
              })
            } else {
              const trimmedRouteName = routeName.trim()
              if (trimmedRouteName == '') {
                return
              }

              this.$router.push({
                name: trimmedRouteName,
                query: { transactionId },
              })
            }
          }
        )
        .catch((error) => {
          this.$handleException({ error })
          this.$router.push({
            name: 'cancelled',
          })
        })
    },
  },
}
</script>

<style scoped lang="scss">
.nedbank-pay-auth-wrapper {
  display: grid;
  place-items: center;
  height: 80%;
  padding: 0 20px 20px 20px;

  @media screen and (max-width: $mobile-resolution) {
    padding: 0;
  }
}

.main-wrapper {
  width: 656px;
  background-color: #fff;
  box-shadow: 0px 5px 15px rgba(166, 166, 166, 0.3);
  border-radius: 8px;
  position: relative;

  @media screen and (max-width: $mobile-resolution) {
    width: 100%;
    height: 100%;
    border-radius: 0;
    box-shadow: none;
  }
}
</style>
